module.exports = __webpack_public_path__ + "img/gps.efe1dd03.svg";